import React, { useState } from 'react';

interface LoginNewProps {
  error?: string;
  callbackUrl?: string;
  providers?: string[];
  onOAuthSignIn?: (provider: string, callbackUrl: string) => Promise<any>;
}

const LoginNew: React.FC<LoginNewProps> = ({
  error,
  callbackUrl = '/',
  providers = ['oidc'],
  onOAuthSignIn
}) => {
  const [loadingProvider, setLoadingProvider] = useState<string | null>(null);

  const effectiveOAuthSignIn =
    onOAuthSignIn ||
    ((provider: string, cb: string) => {
      window.location.href = `/auth/oauth/${provider}?redirect=${encodeURIComponent(cb)}`;
      return Promise.resolve();
    });

  const handleOAuth = async (provider: string) => {
    if (loadingProvider) return;
    setLoadingProvider(provider);
    try {
      await effectiveOAuthSignIn(provider, callbackUrl);
    } finally {
      setLoadingProvider(null);
    }
  };

  return (
    <div className="w-full">
      <div className="rounded-lg border border-gray-200 bg-white p-8 shadow-xl">
        {error && (
          <div
            className="mb-6 rounded-md bg-red-500 p-3 text-sm text-white"
            role="alert"
          >
            {error}
          </div>
        )}

        <h2 className="mb-4 text-xs font-semibold uppercase tracking-wide text-gray-600">
          Single Sign-On
        </h2>

        <div className="grid gap-3">
          {providers.map((p) => (
            <button
              key={p}
              type="button"
              disabled={!!loadingProvider}
              onClick={() => handleOAuth(p)}
              className="flex w-full items-center justify-center gap-2 rounded-md bg-[#042A2C] px-4 py-3 text-sm font-medium text-white transition-colors hover:bg-[#064632] active:bg-[#00271d] disabled:opacity-60"
            >
              {loadingProvider === p ? 'Signing in...' : <>Continue with<b>Work Account</b></>}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoginNew;